import React from 'react'
import NppesSearchView from './NppesSearchView'

const NppesSearch = ({ isQuickSearch = true, applicantId = '' }) => {
    return (
        <div className={`${!isQuickSearch ? 'm-3' : ''}`}>
            <NppesSearchView isQuickSearch={isQuickSearch} applicantId={applicantId} />
        </div>
    )
}

export default NppesSearch
